/**
 * Created by jv on 2019-08-23 (13:53).
 */
import utils from "Sources/utils/utils";
import AppError from "Sources/models/app-error";

const log = require("Sources/utils/logger")();
import RoadUtils from "Sources/components/business-model/road-utils";

class PowerGrid {
  constructor(options) {
    if (utils.isNull(options)) throw new AppError({exception: new Error("Options for BusinessModel cannot be null")});

    this.businessModel = options.businessModel;

    this.id = this.businessModel.id;

    this.containerElement = this.businessModel.containerElement;
    this.layoutData = this.businessModel.layoutData;

    this.canvas = this.businessModel.canvas;
    this.powerGridGroup = null;

    this.powerCabinets = [];
    this.powerLines = [];

    this.activePowerLines = [];

    // this.shouldAbortAnimations = false;

    this.onRenderComplete = options.onRenderComplete;
  }

  render() {
    this.powerGridGroup = new fabric.Group([], {
      hasBorders: false,
      hasControls: false,
      selectable: false,
      evented: false,
      reference: false,
      movable: false,
      visible: false,
      objectCaching: false
    });

    this.canvas.add(this.powerGridGroup);

    this.renderCabinets();
    this.renderPowerLines();

    this._checkRenderComplete();
  }

  _checkRenderComplete() {
    if (this.hasRendered() && utils.isFunction(this.onRenderComplete)) {
      this.powerGridGroup.visible = true;

      this.onRenderComplete.call(this);
    }
  }

  hasRendered() {
    let powerCabinetsRendered = Object.keys(this.layoutData.powerCabinets).length === this.powerCabinets.length;
    let powerLinesRendered = this.layoutData.powerLines.length === this.powerLines.length;

    return powerCabinetsRendered && powerLinesRendered;
  }

  renderCabinets() {
    for (let powerCabinetKey in this.layoutData.powerCabinets) {
      if (this.layoutData.powerCabinets.hasOwnProperty(powerCabinetKey)) {
        this.makePowerCabinet(this.layoutData.powerCabinets[powerCabinetKey])
          .then((powerCabinetGroup) => {
            this._checkRenderComplete();
          });
      }
    }
  }

  makePowerCabinet(powerCabinet) {
    return this.businessModel.loadSvg(this.layoutData.powerGridSettings.cabinetIcon)
      .then((fabricObj) => {
        let powerCabinetGroup = {
          data: powerCabinet
        };

        fabricObj.originX = "center";
        fabricObj.originY = "center";

        fabricObj.top = powerCabinet.position.y;
        fabricObj.left = powerCabinet.position.x;

        fabricObj.scaleToWidth(this.layoutData.powerGridSettings.cabinetSize.width);
        fabricObj.scaleToHeight(this.layoutData.powerGridSettings.cabinetSize.height);

        fabricObj.evented = false;
        fabricObj.selectable = false;
        fabricObj.hasBorders = false;
        fabricObj.hasControls = false;
        fabricObj.reference = false;

        this.powerGridGroup.addWithUpdate(fabricObj);

        powerCabinetGroup.powerCabinetObj = fabricObj;
        this.powerCabinets.push(powerCabinetGroup);

        return powerCabinetGroup;
      })
      .catch((error) => {
        log.error("Failed to load cabinet icon - %o", error);
      });
  }

  renderPowerLines() {
    for (let i = 0; i < this.layoutData.powerLines.length; i++) {
      this.makePowerLine(this.layoutData.powerLines[i])
        .then((powerLineGroup) => {
          this._checkRenderComplete();
        });
    }
  }

  makePowerLine(powerLine) {
    return new Promise((resolve, reject) => {
      let powerLineGroup = {
        data: powerLine,
        pylons: [],
        activeIcons: []
      };

      let outerWidth = this.layoutData.powerGridSettings.outerWidth,
        innerWidth = this.layoutData.powerGridSettings.innerWidth;

      log.debug("Drawing power line '%s'", powerLine.key);

      let connectionsRendered = 0;

      for (let i = 0; i < powerLine.connections.length; i++) {
        let connection = powerLine.connections[i];
        let startPosition = connection.startPosition;
        let endPosition = connection.endPosition;

        let pathString1 = RoadUtils.getPathStringForNavigationOutline(startPosition, connection.navigation, endPosition, outerWidth, "left");
        let pathString2 = RoadUtils.getPathStringForNavigationOutline(startPosition, connection.navigation, endPosition, outerWidth, "right");

        let pathString = pathString1 + " " + pathString2;
        pathString.trim();

        log.debug("Path string for road: %s", pathString);

        powerLineGroup.strokePath = this.drawPowerLine(pathString);

        connectionsRendered++;
      }

      let pylonsRendered = 0;

      for (let i = 0; i < powerLine.pylons.length; i++) {
        this.drawElectricityPylon(powerLine.pylons[i], powerLineGroup)
          .then((pylonObj) => {
            pylonsRendered++;
            checkPowerLineRendered.call(this, connectionsRendered, pylonsRendered, activeIconsRendered);
          });
      }

      let activeIconsRendered = 0;

      for (let i = 0; i < powerLine.activeIcons.length; i++) {
        this.drawPowerLineActiveIcon(powerLine.activeIcons[i], powerLineGroup)
          .then((activeIconObj) => {
            activeIconsRendered++;
            checkPowerLineRendered.call(this, connectionsRendered, pylonsRendered, activeIconsRendered);
          });
      }

      this.powerLines.push(powerLineGroup);

      function checkPowerLineRendered(connectionsRendered, pylonsRendered, activeIconsRendered) {
        let powerLineRendered = powerLine.connections.length === connectionsRendered;
        powerLineRendered = powerLineRendered && powerLine.pylons.length === pylonsRendered;
        powerLineRendered = powerLineRendered && powerLine.activeIcons.length === activeIconsRendered;

        if (powerLineRendered) {
          resolve(powerLineGroup);
        }
      }
    });
  }

  drawPowerLine(pathString) {
    let innerWidth = this.layoutData.powerGridSettings.innerWidth,
      outerWidth = this.layoutData.powerGridSettings.outerWidth;

    /*let background = new fabric.Path(pathString, {
      fill: "transparent",
      stroke: this.layoutData.powerGridSettings.backgroundColor,
      // stroke: "red",
      strokeWidth: innerWidth
    });*/

    let powerLine = new fabric.Path(pathString, {
      fill: "transparent",
      stroke: this.layoutData.powerGridSettings.strokeColor,
      strokeWidth: (outerWidth - innerWidth) / 2,
      hasBorders: false,
      hasControls: false,
      selectable: false,
      evented: false,
      reference: false
    });

    this.powerGridGroup.addWithUpdate(powerLine);

    return powerLine;
  }

  drawPowerLineActiveIcon(position, powerLineGroup) {
    return this.businessModel.loadSvg(this.layoutData.powerGridSettings.activeIcon)
      .then((fabricObj) => {
        fabricObj.originX = "center";
        fabricObj.originY = "center";

        fabricObj.top = position.y;
        fabricObj.left = position.x;

        /*this.canvas.add(new fabric.Line([fabricObj.left, fabricObj.top - 50, fabricObj.left, fabricObj.top + 50], {
          stroke: "red"
        }));
        this.canvas.add(new fabric.Line([fabricObj.left - 50, fabricObj.top, fabricObj.left + 50, fabricObj.top], {
          stroke: "red"
        }));*/

        fabricObj.scaleToWidth(this.layoutData.powerGridSettings.activeIconSize.width);
        fabricObj.scaleToHeight(this.layoutData.powerGridSettings.activeIconSize.height);

        fabricObj.evented = false;
        fabricObj.selectable = false;
        fabricObj.hasBorders = false;
        fabricObj.hasControls = false;
        fabricObj.reference = false;

        fabricObj.visible = false;

        this.powerGridGroup.addWithUpdate(fabricObj);

        powerLineGroup.activeIcons.push(fabricObj);

        return fabricObj;
      })
      .catch((error) => {
        log.error("Failed to load active power line icon - %o", error);
      });
  }

  drawElectricityPylon(position, powerLineGroup) {
    return this.businessModel.loadSvg(this.layoutData.powerGridSettings.pylonIcon)
      .then((fabricObj) => {
        fabricObj.originX = "center";
        fabricObj.originY = "center";

        fabricObj.top = position.y;
        fabricObj.left = position.x;

        /*this.canvas.add(new fabric.Line([fabricObj.left, fabricObj.top - 50, fabricObj.left, fabricObj.top + 50], {
          stroke: "red"
        }));
        this.canvas.add(new fabric.Line([fabricObj.left - 50, fabricObj.top, fabricObj.left + 50, fabricObj.top], {
          stroke: "red"
        }));*/

        fabricObj.scaleToWidth(this.layoutData.powerGridSettings.pylonSize.width);
        fabricObj.scaleToHeight(this.layoutData.powerGridSettings.pylonSize.height);

        fabricObj.evented = false;
        fabricObj.selectable = false;
        fabricObj.hasBorders = false;
        fabricObj.hasControls = false;
        fabricObj.reference = false;

        this.powerGridGroup.addWithUpdate(fabricObj);

        powerLineGroup.pylons.push(fabricObj);

        return fabricObj;
      })
      .catch((error) => {
        log.error("Failed to load pylon icon - %o", error);
      });
  }

  previewPowerlines(points, color) {
    for (let i = 0; i < points.length; i++) {
      let startPoint = points[i].startPoint;
      let endPoint = points[i].endPoint;

      log.info("Previewing power line from '%s' to '%s'", startPoint, endPoint);

      let foundPowerLine = null;

      for (let i = 0; i < this.powerLines.length; i++) {
        let powerLineGroup = this.powerLines[i];
        let powerLineData = powerLineGroup.data;

        if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
          foundPowerLine = powerLineGroup;
        }
      }

      if (utils.isNotNull(foundPowerLine)) {
        foundPowerLine.strokePath.set({stroke: color});

        return foundPowerLine.strokePath;
      } else {
        log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
      }
    }
  }

  activatePowerLines(points) {
    for (let i = 0; i < points.length; i++) {
      this.activatePowerLine(points[i].startPoint, points[i].endPoint);
    }
  }

  activatePowerLine(startPoint, endPoint) {
    log.info("Activating power line from '%s' to '%s'", startPoint, endPoint);

    let foundPowerLine = null;

    for (let i = 0; i < this.powerLines.length; i++) {
      let powerLineGroup = this.powerLines[i];
      let powerLineData = powerLineGroup.data;

      if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
        foundPowerLine = powerLineGroup;
        break;
      }
    }

    if (utils.isNotNull(foundPowerLine)) {
      for (let i = 0; i < this.activePowerLines.length; i++) {
        let powerLineGroup = this.activePowerLines[i];

        if (powerLineGroup.data.key === foundPowerLine.data.key) {
          log.error("Power line [%s] already active", foundPowerLine.data.key);
          return;
        }
      }

      foundPowerLine.strokePath.set({
        stroke: this.layoutData.powerGridSettings.strokeColorActive
      });

      for (let j = 0; j < foundPowerLine.activeIcons.length; j++) {
        let activeIcon = foundPowerLine.activeIcons[j];
        activeIcon.visible = true;
      }

      this.activePowerLines.push(foundPowerLine);

      this.canvas.renderAll();
    } else {
      log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
    }
  }

  deactivateAllPowerLines() {
    for (let i = this.activePowerLines.length - 1; i >= 0; i--) {
      let powerLineGroup = this.activePowerLines[i];
      this._deactivatePowerLine(powerLineGroup, i);
    }
  }

  deactivatePowerLines(points) {
    for (let i = 0; i < points.length; i++) {
      this.deactivatePowerLine(points[i].startPoint, points[i].endPoint);
    }
  }

  deactivatePowerLine(startPoint, endPoint) {
    log.info("Deactivating power line from '%s' to '%s'", startPoint, endPoint);

    let foundIndex = null;
    let foundPowerLine = null;

    for (let i = 0; i < this.activePowerLines.length; i++) {
      let powerLineGroup = this.activePowerLines[i];
      let powerLineData = powerLineGroup.data;

      if (powerLineData.connects.includes(startPoint) && powerLineData.connects.includes(endPoint)) {
        foundIndex = i;
        foundPowerLine = powerLineGroup;
        break;
      }
    }

    if (utils.isNotNull(foundPowerLine)) {
      this._deactivatePowerLine(foundPowerLine, foundIndex);
    } else {
      log.error("No power line found for start point [%s] and end point [%s]", startPoint, endPoint);
    }
  }

  _deactivatePowerLine(powerLine, index) {
    log.info("Deactivating power line %o", powerLine);

    if (utils.isNotNull(powerLine)) {
      powerLine.strokePath.set({
        stroke: this.layoutData.powerGridSettings.strokeColor
      });

      for (let j = 0; j < powerLine.activeIcons.length; j++) {
        let activeIcon = powerLine.activeIcons[j];
        activeIcon.visible = false;
      }

      this.activePowerLines.splice(index, 1);

      this.canvas.renderAll();
    }
  }

  abortAnimations() {
    // Note used in power grid since there are no animations here
    // this.shouldAbortAnimations = true;
  }
}

export default PowerGrid;



// WEBPACK FOOTER //
// ./app/js/components/business-model/power-grid.js